'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var s, r, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)s = n[r], !(t.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(e, s) && (o[s] = e[s]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var s, r, o = {}, n = Object.keys(e);
    for(r = 0; r < n.length; r++)s = n[r], t.indexOf(s) >= 0 || (o[s] = e[s]);
    return o;
}
let u = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    help: 'helpQuery'
};
const StatusMessage = renderWithRef('StatusMessage', null, (r, m)=>{
    let l = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('StatusMessage', r, [
        {
            propName: 'accessibleTextForIcon',
            instructions: getDeprecatedI18nPropMessage(l)
        }
    ]), useComponentStylesLoaded('StatusMessage', SWAN_STYLE_KEY_MAP.statusMessage);
    let { children: f, skin: d = 'info', size: g = 'standard', accessibleTextForIcon: b } = r, h = _object_without_properties(r, [
        "children",
        "skin",
        "size",
        "accessibleTextForIcon"
    ]), w = b;
    return l && !w && (w = l.t(`status-message.accessible-text-for-skin-${d}-icon`)), jsxs(RenderComp, {
        classNames: new Set([
            'swan-status-message',
            `swan-status-message-skin-${d}`,
            `swan-status-message-size-${g}`
        ]),
        root: "div",
        forwardedRef: m,
        props: h,
        children: [
            jsx(Icon, {
                skin: d,
                iconType: u[d],
                size: g,
                alt: w || ''
            }),
            f
        ]
    });
});

export { StatusMessage };
